// Practice-quota API client. Backend: wiki/feature-practice-quota.md.
//
//   GET  /api/practice/quota      (auth optional)
//      → 200 { limit, remaining, scope }
//
// The feature gives anonymous visitors and logged-in users a per-identity daily
// quota of AI practice generations (abuse control + signup nudge, not a paid
// credit). The quota is charged by the content-generation endpoints — a take
// runs session-less and persists nothing server-side
// (wiki/feature-practice-persistence.md). These are plain `fetch` calls via the
// shared client wrappers — no running backend is required to type against this
// contract.

import type { PracticeQuotaResponse } from '@voicedojo/backend-types';
import { api } from './client';

/**
 * Shape returned by `GET /api/practice/quota` and by a quota-429 body — the
 * generated `PracticeQuotaResponse` wire contract (single source of truth),
 * aliased under the FE-facing name the practice runner/stores consume.
 */
export type PracticeQuota = PracticeQuotaResponse;

/** Fetch the caller's remaining daily practice quota. Throws `ApiError` on failure. */
export async function getPracticeQuota(): Promise<PracticeQuota> {
  return api.get<PracticeQuota>('/practice/quota');
}
